/* =====================================================================
   INDUCTION HARDWARE — PRODUCT PAGE INTERACTIONS
   Vanilla JS. One rAF-throttled scroll handler. IntersectionObserver
   for reveals. No heavy libraries — keeps the page fast.
===================================================================== */
function ihPdpInit() {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Mobile menu ---------- */
  var menu = document.getElementById('mobileMenu');
  var navOpen = document.getElementById('navOpen');
  var navClose = document.getElementById('navClose');
  if (menu && navOpen && navClose) {
    navOpen.addEventListener('click', function () { menu.classList.add('open'); menu.setAttribute('aria-hidden', 'false'); });
    navClose.addEventListener('click', function () { menu.classList.remove('open'); menu.setAttribute('aria-hidden', 'true'); });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { menu.classList.remove('open'); menu.setAttribute('aria-hidden', 'true'); });
    });
  }

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.reveal, .feature, .callout');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- Gallery (header) ---------- */
  (function () {
    var stage = document.getElementById('galleryStage');
    if (!stage) return;
    var imgs = stage.querySelectorAll('.gallery__img');
    var thumbs = document.querySelectorAll('#galleryThumbs .thumb');
    var prev = document.getElementById('galPrev');
    var next = document.getElementById('galNext');
    var i = 0;
    function show(n) {
      i = (n + imgs.length) % imgs.length;
      imgs.forEach(function (img, k) { img.classList.toggle('active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('active', k === i); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    show(0);
  })();

  /* ---------- Mode switcher ---------- */
  (function () {
    var tabs = document.querySelectorAll('.mode-tab');
    if (!tabs.length) return;
    var imgs = document.querySelectorAll('#modeMedia img');
    var panes = document.querySelectorAll('#modeBody .pane');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-mode');
        tabs.forEach(function (t) { t.classList.toggle('active', t === tab); });
        imgs.forEach(function (im) { im.classList.toggle('active', im.getAttribute('data-mode') === key); });
        panes.forEach(function (p) { p.classList.toggle('active', p.getAttribute('data-mode') === key); });
      });
    });
  })();

  /* ---------- Boil timer demo ---------- */
  (function () {
    var btn = document.getElementById('boilBtn');
    if (!btn) return;
    var readout = document.getElementById('boilReadout');
    var ihFill = document.getElementById('boilIH');
    var gasFill = document.getElementById('boilGas');
    var ihTime = document.getElementById('boilIHTime');
    var gasTime = document.getElementById('boilGasTime');
    var running = false;
    function run() {
      if (running) return;
      running = true;
      btn.textContent = 'Boiling…';
      var start = performance.now();
      var IH_SEC = 88, GAS_SEC = 240, SHOW = 2600; // animate over 2.6s
      function frame(now) {
        var p = Math.min((now - start) / SHOW, 1);
        var ihShown = Math.round(p * IH_SEC);
        ihFill.style.width = (p * 100) + '%';
        var gasP = Math.min(p * (IH_SEC / GAS_SEC), 1); // gas still going when IH done
        gasFill.style.width = (gasP * 100) + '%';
        readout.innerHTML = ihShown + '<small>s</small>';
        ihTime.textContent = ihShown + 's';
        gasTime.textContent = Math.round(gasP * GAS_SEC) + 's';
        if (p < 1) { requestAnimationFrame(frame); }
        else {
          readout.innerHTML = IH_SEC + '<small>s</small>';
          ihTime.textContent = IH_SEC + 's';
          gasTime.textContent = '4:00+';
          btn.textContent = 'Boil again';
          running = false;
        }
      }
      requestAnimationFrame(frame);
    }
    btn.addEventListener('click', run);
  })();

  /* ---------- Specs tabs ---------- */
  (function () {
    var nav = document.querySelector('.specs__nav');
    var panels = Array.prototype.slice.call(document.querySelectorAll('.specs__panel'));
    if (!nav || !panels.length) return;
    function show(key) {
      nav.querySelectorAll('button').forEach(function (b) { b.classList.toggle('active', b.getAttribute('data-spec') === key); });
      panels.forEach(function (p) { p.classList.toggle('active', p.getAttribute('data-spec') === key); });
    }
    /* Build the tab buttons from each panel's title (theme-block panels carry data-title). */
    if (!nav.querySelector('button')) {
      panels.forEach(function (p, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('data-spec', p.getAttribute('data-spec') || '');
        b.textContent = p.getAttribute('data-title') || ('Tab ' + (i + 1));
        b.addEventListener('click', function () { show(b.getAttribute('data-spec')); });
        nav.appendChild(b);
      });
    } else {
      nav.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () { show(b.getAttribute('data-spec')); });
      });
    }
    /* Activate the first tab on load. */
    show(panels[0].getAttribute('data-spec'));
  })();

  /* ---------- Add to cart toast ---------- */
  (function () {
    var toast = document.getElementById('toast');
    function ping(msg) {
      if (!toast) return;
      if (msg) toast.querySelector('span').textContent = msg;
      toast.classList.add('show');
      clearTimeout(ping._t);
      ping._t = setTimeout(function () { toast.classList.remove('show'); }, 2400);
    }
    document.querySelectorAll('[data-add-to-cart]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        ping('Added to cart — 48″ Pro Induction Range');
      });
    });
  })();

  /* ---------- Film: multi-video gallery (mp4 file OR YouTube/Vimeo embed) ---------- */
  (function () {
    var frame = document.getElementById('filmFrame');
    if (!frame || frame.__ihBound) return;
    frame.__ihBound = true;
    var poster = document.getElementById('filmPoster');
    var play = document.getElementById('filmPlay');
    var thumbs = document.querySelectorAll('#filmThumbs .film__thumb');

    function embedSrc(url) {
      if (!url) return null;
      var u = url.trim(), m;
      m = u.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{11})/);
      if (m) return 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1&rel=0&playsinline=1';
      m = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (m) return 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1';
      if (/(youtube\.com\/embed\/|player\.vimeo\.com\/video\/)/.test(u)) {
        return u + (u.indexOf('?') === -1 ? '?autoplay=1' : '&autoplay=1');
      }
      return null;
    }

    function showPoster(videoUrl, embedUrl, posterUrl) {
      var media = frame.querySelector('video, iframe');
      if (media) media.remove();
      if (poster) { if (posterUrl) poster.src = posterUrl; poster.style.display = ''; }
      if (play) {
        play.setAttribute('data-video', videoUrl || '');
        play.setAttribute('data-embed', embedUrl || '');
        var has = videoUrl || embedUrl;
        play.hidden = !has;
        if (has) play.style.display = '';
      }
    }

    function playActive() {
      if (!play) return;
      var embed = embedSrc(play.getAttribute('data-embed'));
      var file = play.getAttribute('data-video');
      var el;
      if (embed) {
        el = document.createElement('iframe');
        el.src = embed;
        el.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
        el.setAttribute('allowfullscreen', '');
        el.setAttribute('title', 'Video player');
      } else if (file) {
        el = document.createElement('video');
        el.src = file; el.controls = true; el.autoplay = true; el.playsInline = true;
        el.setAttribute('playsinline', '');
      } else { return; }
      if (poster) poster.style.display = 'none';
      play.style.display = 'none';
      frame.appendChild(el);
      if (el.play) { var p = el.play(); if (p && p.catch) p.catch(function () {}); }
    }

    if (play) play.addEventListener('click', playActive);

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.toggle('active', x === t); });
        showPoster(t.getAttribute('data-video'), t.getAttribute('data-embed'), t.getAttribute('data-poster'));
      });
    });
  })();

  /* ---------- Horizontal scroller arrows ---------- */
  (function () {
    var track = document.getElementById('ucScroll');
    if (!track) return;
    var prev = document.getElementById('ucPrev');
    var next = document.getElementById('ucNext');
    function step() {
      var item = track.querySelector('.hscroll__item');
      return item ? item.getBoundingClientRect().width + 24 : 360;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  })();

  /* ---------- Sticky buy bar + hero parallax (one scroll handler) ---------- */
  (function () {
    var buybar = document.getElementById('buybar');
    var anchor = document.getElementById('buyAnchor');   // when this scrolls out, show bar
    var footer = document.querySelector('.shopify-section-group-footer-group, footer, .footer');
    var floatEl = document.getElementById('heroFloat');  // parallax target
    var ticking = false;

    function update() {
      ticking = false;
      var y = window.pageYOffset;

      // Sticky buy bar
      if (buybar && anchor) {
        var aBottom = anchor.getBoundingClientRect().bottom;
        var nearFooter = false;
        if (footer) {
          var fTop = footer.getBoundingClientRect().top;
          nearFooter = fTop < window.innerHeight - 40;
        }
        if (aBottom < 0 && !nearFooter) buybar.classList.add('show');
        else buybar.classList.remove('show');
      }

      // Hero parallax — gentle drift + scale as you scroll past the top hero
      if (floatEl && !reduceMotion && window.innerWidth >= 760) {
        var amp = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--motion-parallax')) || 1;
        if (y < window.innerHeight * 1.3) {
          var prog = Math.min(y / (window.innerHeight * 0.9), 1); // 0..1 through first screen
          var shift = prog * 46 * amp;
          var scale = 1 + prog * 0.06 * amp;
          floatEl.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0) scale(' + scale.toFixed(3) + ')';
        }
      }
    }
    function onScroll() {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  })();

  /* ---------- Hero entrance float ---------- */
  (function () {
    if (reduceMotion) return;
    var hero = document.getElementById('heroFloat');
    if (!hero) return;
    hero.style.opacity = '0';
    hero.style.transition = 'opacity 1s var(--ease-out), filter 1s var(--ease-out)';
    hero.style.filter = 'blur(6px)';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        hero.style.opacity = '1';
        hero.style.filter = 'none';
      });
    });
  })();

  /* ---------- Lifetime warranty popover ---------- */
  (function () {
    var wrap = document.getElementById('warranty');
    var trigger = document.getElementById('warrantyTrigger');
    if (!wrap || !trigger || trigger.__ihBound) return;
    trigger.__ihBound = true;
    function setOpen(open) {
      wrap.classList.toggle('open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      setOpen(!wrap.classList.contains('open'));
    });
    document.addEventListener('click', function (e) {
      if (wrap.classList.contains('open') && !wrap.contains(e.target)) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  })();

  /* ---------- "Complete your kitchen" carousel arrows ---------- */
  (function () {
    var track = document.getElementById('cmatchTrack');
    if (!track) return;
    var prev = document.getElementById('cmPrev');
    var next = document.getElementById('cmNext');
    function step() {
      var c = track.querySelector('.cmatch-card');
      return c ? c.getBoundingClientRect().width + 12 : 208;
    }
    function sync() {
      var overflow = track.scrollWidth > track.clientWidth + 2;
      if (prev) prev.style.display = overflow ? '' : 'none';
      if (next) next.style.display = overflow ? '' : 'none';
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    window.addEventListener('resize', sync);
    if (window.ResizeObserver) { new ResizeObserver(sync).observe(track); }
    if (document.readyState === 'complete') { sync(); } else { window.addEventListener('load', sync); }
  })();
}

if (!window.__ihPdpBound) {
  window.__ihPdpBound = true;
  if (document.readyState !== 'loading') { ihPdpInit(); }
  else { document.addEventListener('DOMContentLoaded', ihPdpInit); }
  document.addEventListener('shopify:section:load', ihPdpInit);
}
